import React, { useEffect, useState }                             from 'react'
import axios                                                      from 'axios'
import { Grid, Typography }                                       from'@material-ui/core'
import { CLIENT_PUBLIC_TOKEN }                                    from '../../config'
import { node_server }                                            from '../../Helpers'

const GetFirstLoginOnly = () => {

   const [ listToDisplay,     setListToDisplay  ]  =  useState()
   
   const handleClick = async (userId) => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.put(node_server + `admin/analytics/reset/${userId}`)
         .then( res => console.log('GetFirstLoginOnly res.data is', res.data ))
   }

   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'admin/analytics/getFirstLoginOnly')
         .then( res => res.data )
         .then( data => {
            setListToDisplay(
               data.data.map( (d, i) => {
                  console.log('d is', d)
                  return(
                     <Grid container direction='row' key={d.userId} >
                        <Grid item xs={4} >
                           <Typography align='left' onClick={() => handleClick(d.userId)} >
                              { d.username }
                           </Typography>
                        </Grid>
                        <Grid item xs={2} >
                           <Typography align='center' onClick={() => handleClick(d.userId)} >
                              { d.isActive }
                           </Typography>
                        </Grid>
                        <Grid item xs={4} >
                           <Typography align='left' onClick={() => handleClick(d.userId)} >
                              { d.lastLoginDate }
                           </Typography>
                        </Grid>
                     </Grid>
                  )
               })
            )
         })
         .catch( (error) => {
            console.error(error)
         })
   }, [])

   return(
      <Grid>
         <Typography variant='h6'>
            First Login Only
         </Typography>
         <Grid container direction='row'>
            <Grid item xs={4} >
               <Typography>
                  Username
               </Typography>
            </Grid>
            <Grid item xs={2} >
               <Typography>
                  Is Active
               </Typography>
            </Grid>
            <Grid item xs={4} >
               <Typography align='left'>
                  Last Login Date
               </Typography>
            </Grid>
         </Grid>
         <Grid item xs={12} align='left' style={{ border: '2px solid darkgray', borderRadius: '0.5rem', height: '250px', marginTop: '0.5rem', overflow: 'scroll', padding: '1rem', width: '50rem' }} >
            { listToDisplay }
         </Grid>
      </Grid>
   )
}

export default GetFirstLoginOnly
